// Utilitários para formatação de valores monetários e preços

/**
 * Formata um valor monetário para exibição
 * @param {string|number} valor - O valor a ser formatado
 * @param {string} prefixo - Prefixo da moeda (padrão: 'R$ ')
 * @returns {string} Valor formatado ou '0.00' se inválido
 */
export const formatarPreco = (valor, prefixo = 'R$ ') => {
  if (valor === null || valor === undefined || valor === '') {
    return `${prefixo}0,00`;
  }
  
  const valorNumerico = parseFloat(valor);
  
  if (isNaN(valorNumerico)) {
    console.warn('Valor inválido para formatação:', valor);
    return `${prefixo}0,00`;
  }
  
  // Formatar usando padrão brasileiro (vírgula como separador decimal)
  return `${prefixo}${valorNumerico.toFixed(2).replace('.', ',')}`;
};

/**
 * Converte um valor para número, retornando 0 se inválido
 * @param {string|number} valor - O valor a ser convertido
 * @returns {number} Valor numérico ou 0 se inválido
 */
export const converterParaNumero = (valor) => {
  if (valor === null || valor === undefined || valor === '') {
    return 0;
  }
  
  const valorNumerico = parseFloat(valor);
  
  if (isNaN(valorNumerico)) {
    console.warn('Valor inválido para conversão:', valor);
    return 0;
  }
  
  return valorNumerico;
};

/**
 * Calcula o subtotal de um item
 * @param {string|number} preco - Preço unitário
 * @param {string|number} quantidade - Quantidade
 * @returns {number} Subtotal calculado
 */
export const calcularSubtotal = (preco, quantidade) => {
  const precoNumerico = converterParaNumero(preco);
  const quantidadeNumerica = converterParaNumero(quantidade);
  
  return precoNumerico * quantidadeNumerica;
};

/**
 * Formata um valor para exibição sem prefixo de moeda
 * @param {string|number} valor - O valor a ser formatado
 * @returns {string} Valor formatado ou '0.00' se inválido
 */
export const formatarValor = (valor) => {
  if (valor === null || valor === undefined || valor === '') {
    return '0,00';
  }
  
  const valorNumerico = parseFloat(valor);
  
  if (isNaN(valorNumerico)) {
    console.warn('Valor inválido para formatação:', valor);
    return '0,00';
  }
  
  // Formatar usando padrão brasileiro (vírgula como separador decimal)
  return valorNumerico.toFixed(2).replace('.', ',');
};

/**
 * Formata um valor monetário usando Intl.NumberFormat (padrão brasileiro)
 * @param {string|number} valor - O valor a ser formatado
 * @returns {string} Valor formatado no padrão brasileiro
 */
export const formatarMoeda = (valor) => {
  if (valor === null || valor === undefined || valor === '') {
    return 'R$ 0,00';
  }
  
  const valorNumerico = parseFloat(valor);
  
  if (isNaN(valorNumerico)) {
    console.warn('Valor inválido para formatação:', valor);
    return 'R$ 0,00';
  }
  
  // Formatação manual para garantir padrão brasileiro
  const parteInteira = Math.floor(valorNumerico);
  const parteDecimal = Math.round((valorNumerico - parteInteira) * 100);
  
  // Formatar parte inteira com pontos para milhares
  const parteInteiraFormatada = parteInteira.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  
  // Formatar parte decimal sempre com 2 dígitos
  const parteDecimalFormatada = parteDecimal.toString().padStart(2, '0');
  
  return `R$ ${parteInteiraFormatada},${parteDecimalFormatada}`;
};

const formatters = {
  formatarPreco,
  converterParaNumero,
  calcularSubtotal,
  formatarValor,
  formatarMoeda
};

export default formatters; 